import type { ListBuilderList } from '../../../types';
import {
	duplicateAccountColumn,
	duplicateGroupColumn,
	duplicateLicenseColumn,
	reviewedGroupActionColumn,
	reviewNoteColumn,
	reviewOutcomeColumn,
	shipToColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';
import { COMPLIANCE_ATTENTION_LIST_IDS } from '../list-ids';
import { DUPLICATE_GROUP_SORT_OPTIONS } from './duplicate-group-sort';

/**
 * Shared License — REVIEWED (PD-16653). The groups a decision is hiding from
 * the Shared License list: "Being fixed" (back after 14 days, soonest first)
 * and "Fine as is" (until an account or copy is added, removed or re-pointed).
 * Each row shows the decision, its note, and who made it when; Open shows the
 * group review, where the decision can be reopened.
 */
export const sharedLicenseReviewedList: ListBuilderList = {
	id: COMPLIANCE_ATTENTION_LIST_IDS.sharedLicenseReviewed,
	cacheTTL: 300000,
	name: 'Shared Reviewed',
	type: 'default',
	active: true,
	sortOrder: 15,
	filterRules: {
		...hideOtherCardFilters(['licenseSharedLicense']),
		licenseSharedLicense: {
			defaultValue: [
				{ id: 'reviewed', label: 'Reviewed: Fine as is or Being fixed' },
			],
			locked: true,
		},
	},
	columns: [
		duplicateGroupColumn,
		duplicateAccountColumn,
		shipToColumn,
		duplicateLicenseColumn,
		reviewOutcomeColumn,
		reviewNoteColumn,
		reviewedGroupActionColumn,
	],
	sortOptions: DUPLICATE_GROUP_SORT_OPTIONS,
	defaultSortId: 'group-risk',
};
